import { CognitoUserPool } from "amazon-cognito-identity-js";
import api from "./api";

let userPoolPromise = null;

const initializeUserPool = async () => {
  if (userPoolPromise) {
    return userPoolPromise;
  }

  userPoolPromise = (async () => {
    try {
      const response = await api.get("/api/config/cognito/");
      const config = response.data;

      if (!config.USER_POOL_ID || !config.CLIENT_ID) {
        throw new Error("Missing Cognito configuration");
      }

      const poolData = {
        UserPoolId: config.USER_POOL_ID,
        ClientId: config.CLIENT_ID,
      };

      return new CognitoUserPool(poolData);
    } catch (error) {
      console.error("Error initializing UserPool:", error);
      userPoolPromise = null;
      throw error;
    }
  })();

  return userPoolPromise;
};

let cachedPool = null;

initializeUserPool()
  .then((pool) => {
    cachedPool = pool;
  })
  .catch((error) => {
    console.error("Failed to initialize UserPool:", error);
  });

// Export a proxy object that behaves like CognitoUserPool
const UserPool = new Proxy(
  {},
  {
    get(target, prop) {
      if (!cachedPool) {
        throw new Error("UserPool not initialized yet. Please wait...");
      }
      return cachedPool[prop];
    },
  },
);

export default UserPool;
